import { authorClient } from "@/api/authorClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import { CreateResourceReq, UpdateResourceReq, DeleteResourceReq, ListResourceReq } from "@/pbjs/external/auth/auth_pb";
// lee 绩效接口参数
interface Options {
  name?: string; // 名字
  route?: string;  // 路由
  annotation?: string; // 注释
  resourceId?: string; //资源ID
  pageIndex: number;
  pageSize: number;
}
// 创建路由
export function createRouter(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new CreateResourceReq();
      request.setCommonin(setCommon());
      request.setName(arg.name);
      request.setRoute(arg.route);
      // setRank
      let _res = await authorClient.createResource(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 更新路由
export function updateRouter(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new UpdateResourceReq();
      request.setCommonin(setCommon());
      request.setResourceid(arg.resourceId);
      request.setName(arg.name);
      request.setRoute(arg.route);
      // setRank
      let _res = await authorClient.updateResource(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 删除路由
export function deleteRouter(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DeleteResourceReq();
      request.setCommonin(setCommon());
      request.setResourceid(arg.resourceId);
      // setRank
      let _res = await authorClient.deleteResource(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 查询
export function listRouter(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListResourceReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize))
      request.setName(arg.name);
      // setRank
      let _res = await authorClient.listResource(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
